var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSquare = function SvgSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "square_svg__a",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.8,
    height: 17.8,
    x: 3.1,
    y: 3.1,
    fill: "#000",
    rx: 2.25
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#square_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 3h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 3h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 3h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 3h3v3h-3zM3 6h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 6h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 6h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 6h3v3h-3zM3 9h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 9h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 9h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 9h3v3h-3zM3 12h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 12h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 12h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 12h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 12h3v3h-3zM3 15h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M6 15h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 15h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M12 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 15h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M18 15h3v3h-3zM3 18h3v3H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 18h3v3H6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M9 18h3v3H9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b2b2b2",
    d: "M15 18h3v3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18 18h3v3h-3z"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    fill: "currentColor",
    rx: 2.25,
    style: {
      stroke: "var(--accent-stroke)",
      strokeWidth: "var(--accent-stroke-width)"
    }
  }));
};
export default SvgSquare;